import React from 'react';
import { Render, CollapsiblePanel } from '../platformui/';

const ExpandableBlock = (props) => {
  return (
    <CollapsiblePanel
      className="c-expandable-list"
      Heading={Render.Property(props.Heading, 'Heading')}
      Dir={props.Dir}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: Render.Property(props.Content, 'Content'),
        }}
      ></div>
    </CollapsiblePanel>
  );
};

export default ExpandableBlock;
